import { ZapVersions } from '@ctw/shared/context/zui-provider';
import { trimStart } from 'lodash-es';

// The path prefixes each ZAP-embedding app mounts its routes under. Order matters:
// longer prefixes must precede shorter ones they contain (e.g. `/zap-v2` before `/zap`)
// so the more specific prefix is stripped first.
// IMPORTANT! This logic to determine the correct navigation path is also found in apps/zap-iframe/src/App.tsx
// If you are making updates you may need to update both places.
export const ZAP_APP_PATH_PREFIXES = [
  '/salesforce/v1',
  '/vim/v1',
  '/zap-v2',
  '/zap',
  ...ZapVersions.map((version) => `/${version}`),
];

export const pathWithParameters = (
  url: string,
  parameters: Record<string, unknown>,
  preserveParameters: Array<string> = [],
): string => {
  const currentUrl = new URL(window.location.href);
  const newUrl = new URL(url, `${window.location.protocol}//${window.location.host}`);

  for (const [key, value] of Object.entries(parameters)) {
    if (value === null) {
      newUrl.searchParams.delete(key);
    } else {
      newUrl.searchParams.set(key, String(value));
    }
  }

  for (const parameter of preserveParameters) {
    if (currentUrl.searchParams.has(parameter)) {
      newUrl.searchParams.set(parameter, currentUrl.searchParams.get(parameter) ?? '');
    }
  }

  let newPathname = newUrl.pathname;

  // Check if pathname starts with any of the prefixes and remove it
  for (const prefix of ZAP_APP_PATH_PREFIXES) {
    if (newPathname.startsWith(prefix)) {
      newPathname = newPathname.substring(prefix.length);
      break;
    }
  }

  return `${newPathname}${newUrl.search}${newUrl.hash}`;
};

interface HrefIsActiveOptions {
  href: string;
  pathname: string;
}

export const hrefIsActive = ({ href, pathname }: HrefIsActiveOptions): boolean => {
  const nonRelativeHref = href.replaceAll('.', '');
  const normalizedHref = trimStart(
    nonRelativeHref[0] === '/' ? nonRelativeHref.slice(1) : nonRelativeHref,
  );

  return pathname.includes(`${normalizedHref}`);
};
